import React from "react";
import AuthenticatedUserLayout from "../layouts/AuthenticatedUserLayout";
import {AuthorizedContextProvider} from "../context/AuthorizedContext";
import {Helmet} from "react-helmet";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import queryString from 'query-string';
import CloseBottomBar from "../components/core/CloseBottomBar";
import {SHIPMENT_TRACKING_PAGE_PATH} from "../layouts/navigation/Navigator";
import SingleShipmentDetailsComponents
    from "../components/page-single-shipment-details/SingleShipmentDetailsComponents";
import AddEventCommentButtonsToolbar from "../components/core/shipments/AddEventCommentButtonsToolbar";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import {IShipment} from "../components/core/shipments/ShipmentList";
import { normalizeToString } from "../utils/QueryParamNormalizerUtils";


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flex: 1,
            marginBottom: 80
        }

    })
);


const SingleShipmentDetailsPage = () => {

    const {t} = useTranslation();

    const classes = useStyles();
    const navigate = useNavigate();
    const location = useLocation();

    const [shipment, setShipment] = React.useState<IShipment | undefined>(undefined);
    const {redirect} = queryString.parse(location.search);
    const {uuid} = useParams();
    const shipmentTitle = shipment ? ` - ${shipment.spotID} (${t("core.modality." + shipment.modality)})` : "";


    return (<AuthorizedContextProvider>

            <Helmet>
                <title>{t("page.title.shipment-tracking")}</title>
                <meta name="description" content={t("page.title.shipment-tracking")}/>
            </Helmet>

            <div className={classes.root}>
                <AuthenticatedUserLayout pageTitle={t("page.title.shipment-tracking") + shipmentTitle}>

                    {uuid && <AddEventCommentButtonsToolbar uuid={uuid} shipmentId={shipment?.shipmentId}/>}

                    <SingleShipmentDetailsComponents setShipment={setShipment}/>

                </AuthenticatedUserLayout>

            </div>

            <CloseBottomBar executeClose={() => navigate(normalizeToString(redirect) ?? SHIPMENT_TRACKING_PAGE_PATH)}/>

        </AuthorizedContextProvider>
    );


};

export default SingleShipmentDetailsPage;
